import apiClient from "../utils/apiClient";
import {
  PAID_USERS_REPORT_REQUEST,
  PAID_USERS_REPORT_SUCCESS,
  PAID_USERS_REPORT_FAIL,
  PAID_USERS_LIST_REQUEST,
  PAID_USERS_LIST_SUCCESS,
  PAID_USERS_LIST_FAIL,
  CLEAR_REPORT_ERRORS,
  REVENUE_REPORT_REQUEST,
  REVENUE_REPORT_SUCCESS,
  REVENUE_REPORT_FAIL,
  CONVERSION_REPORT_REQUEST,
  CONVERSION_REPORT_SUCCESS,
  CONVERSION_REPORT_FAIL,
  RETENTION_REPORT_REQUEST,
  RETENTION_REPORT_SUCCESS,
  RETENTION_REPORT_FAIL,
} from "../constants/adminReportConstants";

/**
 * Get paid users report
 */
export const getPaidUsersReport = (dateRange = "last30days", startDate = null, endDate = null) => async (dispatch) => {
  try {
    dispatch({
      type: PAID_USERS_REPORT_REQUEST,
    });

    let url = `/admin/reports/paid-users?dateRange=${dateRange}`;
    if (dateRange === "custom" && startDate && endDate) {
      url += `&startDate=${startDate}&endDate=${endDate}`;
    }

    const { data } = await apiClient.get(url);

    dispatch({
      type: PAID_USERS_REPORT_SUCCESS,
      payload: data.data,
    });
  } catch (error) {
    dispatch({
      type: PAID_USERS_REPORT_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

/**
 * Get paid users list (paginated)
 */
export const getPaidUsersList = (
  page = 1,
  limit = 10,
  dateRange = "last30days",
  startDate = null,
  endDate = null,
  sortBy = "subscribedAt",
  sortOrder = "desc"
) => async (dispatch) => {
  try {
    dispatch({
      type: PAID_USERS_LIST_REQUEST,
    });

    let url = `/admin/reports/paid-users-list?page=${page}&limit=${limit}&dateRange=${dateRange}&sortBy=${sortBy}&sortOrder=${sortOrder}`;
    if (dateRange === "custom" && startDate && endDate) {
      url += `&startDate=${startDate}&endDate=${endDate}`;
    }

    const { data } = await apiClient.get(url);

    dispatch({
      type: PAID_USERS_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: PAID_USERS_LIST_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

/**
 * Clear report errors
 */
export const clearReportErrors = () => (dispatch) => {
  dispatch({
    type: CLEAR_REPORT_ERRORS,
  });
};

/**
 * Get revenue report
 */
export const getRevenueReport = (dateRange = "last30days", startDate = null, endDate = null) => async (dispatch) => {
  try {
    dispatch({ type: REVENUE_REPORT_REQUEST });
    let url = `/admin/reports/revenue?dateRange=${dateRange}`;
    if (dateRange === "custom" && startDate && endDate) url += `&startDate=${startDate}&endDate=${endDate}`;
    const { data } = await apiClient.get(url);
    dispatch({ type: REVENUE_REPORT_SUCCESS, payload: data.data || data });
  } catch (error) {
    dispatch({ type: REVENUE_REPORT_FAIL, payload: error.response?.data?.message || error.message });
  }
};

/**
 * Get conversion report
 */
export const getConversionReport = (dateRange = "last30days", startDate = null, endDate = null) => async (dispatch) => {
  try {
    dispatch({ type: CONVERSION_REPORT_REQUEST });
    let url = `/admin/reports/conversion?dateRange=${dateRange}`;
    if (dateRange === "custom" && startDate && endDate) url += `&startDate=${startDate}&endDate=${endDate}`;
    const { data } = await apiClient.get(url);
    dispatch({ type: CONVERSION_REPORT_SUCCESS, payload: data.data || data });
  } catch (error) {
    dispatch({ type: CONVERSION_REPORT_FAIL, payload: error.response?.data?.message || error.message });
  }
};

/**
 * Get retention report
 */
export const getRetentionReport = (dateRange = "last30days", startDate = null, endDate = null) => async (dispatch) => {
  try {
    dispatch({ type: RETENTION_REPORT_REQUEST });
    let url = `/admin/reports/retention?dateRange=${dateRange}`;
    if (dateRange === "custom" && startDate && endDate) url += `&startDate=${startDate}&endDate=${endDate}`;
    const { data } = await apiClient.get(url);
    dispatch({ type: RETENTION_REPORT_SUCCESS, payload: data.data || data });
  } catch (error) {
    dispatch({ type: RETENTION_REPORT_FAIL, payload: error.response?.data?.message || error.message });
  }
};
